
import React from "react";
import { cn } from "@/lib/utils";
import { colorOptions } from "@/utils/colorOptions";

interface ColorPickerProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ value, onChange, className }) => {
  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {colorOptions.map((color) => (
        <button
          key={color.value}
          type="button"
          className={cn(
            "w-6 h-6 rounded-full border transition-all",
            value === color.value 
              ? "ring-2 ring-offset-2 ring-black dark:ring-white" 
              : "hover:scale-110"
          )}
          style={{ backgroundColor: color.value }}
          onClick={() => onChange(color.value)}
          title={color.name}
        />
      ))}
    </div>
  );
};

export default ColorPicker;
